import React, { SVGProps } from 'react';

const SmallInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="SmallInfo">
    <path
      d="M7 12.833A5.833 5.833 0 1 1 7 1.167a5.833 5.833 0 0 1 0 11.666Zm0-1.166a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333Zm-.583-7.584h1.166V5.25H6.417V4.083Zm0 2.334h1.166v3.5H6.417v-3.5Z"
      fill="#F6A609"
    />
  </svg>
);

export default SmallInfo;
